import { BasicConfig } from '../models/basic-config.interface';

export abstract class UsersConfig extends BasicConfig {
  privileges: {};
}

export type UsersPrivileges = UsersConfig['privileges'];
